export default class Seller {
  id?: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
  }

  public static of(obj: any): Seller {
    return new Seller(obj || {});
  }

  public static ofList(obj: any[]): Seller[] {
    return obj.map(this.of);
  }
}
